var render = function render(_c,_vm){return _c('div',{class:['Headline', _vm.data.class, _vm.data.staticClass]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }